// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__24g8m","content":"ManualTimeModal_content__X6iZX"};